import PageLoader from "components/PageLoader"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import {
  BaseHeaderLayout,
  Box,
  ContentLayout,
  IconButton,
  LinkButton,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Typography,
} from "@strapi/design-system"
import { Pencil, Plus } from "@strapi/icons"
import { useBrandsQuery } from "hooks/query/useBrandsQuery"

export const BrandsPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { data: brands, isLoading } = useBrandsQuery()

  return (
    <Box>
      <BaseHeaderLayout
        title={t("brandsPage.title")}
        as={"h1"}
        primaryAction={
          <LinkButton startIcon={<Plus />} target="_self" href={`/brands/add`}>
            {t("brandsPage.addBrand")}
          </LinkButton>
        }
        subtitle={t("brandsPage.subtitle", { count: brands.length })}
      />
      <ContentLayout>
        {!!brands.length && (
          <Table>
            <Thead>
              <Tr>
                <Th>{t("brandsPage.brandName")}</Th>
                <Th>{t("brandsPage.brandSlug")}</Th>
                <Th></Th>
              </Tr>
            </Thead>
            <Tbody>
              {brands.map((brand) => (
                <Tr key={brand.name}>
                  <Td>
                    <Typography textColor="neutral800">{brand.name}</Typography>
                  </Td>
                  <Td>{brand.slug}</Td>
                  <Td>
                    <IconButton
                      onClick={() => navigate(`/brands/edit?id=${brand.id}`)}
                      label={t("brandsPage.editLabel")}
                      icon={<Pencil />}
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}
        {isLoading && <PageLoader />}
      </ContentLayout>
    </Box>
  )
}
